import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const dashboardEditEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "dashboard-edit-entrypoint" */ './src/index.tsx'),
	),
	getPreloadProps: () => {
		return {};
	},
});
